import React from 'react'
import { Box, Paper, Flex, Image, Anchor, Text, Button, Badge } from '@mantine/core'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { IconTrash } from '@tabler/icons-react'
import { deleteQcItem } from '../../../../../services/quality-control'
import { modalDeleteData } from '../../../../ui/Prompt/modalDeleteData'

const OrderGeneralQcList = ({ dataGeneralQc, reloadList }) => {
  const navigate = useNavigate()

  const toDetailUser = (dataUser) => {
    if (dataUser !== null) {
      navigate(`/users/${dataUser.id}`)
    }
  }

  const handleDeleteQcItem = (val) => {
    modalDeleteData('QC Photo General', val.id, val.status, deleteQcItem, reloadList)
  }

  return (
    <Paper shadow="md" radius="md" withBorder p='sm'>
      <Flex justify='space-between' align='start'>
        <Flex gap='sm' align='start'>
          <Paper shadow="sm" w={142} withBorder radius='md'>
            <Image w={140} h={140} radius='md' src={dataGeneralQc.image !== null ? dataGeneralQc.image : NoImage} />
          </Paper>
          <Box>
            <Badge size='sm' variant="filled" color="green.6" tt='capitalize' fw='500' mb={4}>
              {dataGeneralQc.status}
            </Badge>
            <Box>
              <Anchor href={dataGeneralQc.image} fz={12} target="_blank" underline="hover" c='blue'>{dataGeneralQc.image || '-' }</Anchor>
            </Box>
            <Text fz='xs' mb={2}>Uploaded by:
              <Anchor
                underline="hover"
                fz='xs'
                c={dataGeneralQc.created_by !== null ? 'blue' : 'gray.6'}
                fw='bold'
                onClick={() => toDetailUser(dataGeneralQc.created_by)}
              >{dataGeneralQc.created_by !== null ? ` ${dataGeneralQc.created_by.name}` : 'Unknown User'}</Anchor>
            </Text>
            <Text fz={11} mb={1}>{dayjs(dataGeneralQc.created_at).format('DD/MMMM/YYYY HH:mm:ss')}</Text>
            <Text fz={11} c='gray.9'>Note:</Text>
            <Text fz={11} lineClamp={2} c='gray.9'>{dataGeneralQc.note || '-'}</Text>
          </Box>
        </Flex>
        <Button size='xs' leftSection={<IconTrash size={14} />} onClick={() => handleDeleteQcItem(dataGeneralQc)}>Delete</Button>
      </Flex>
    </Paper>
  )
}

export default OrderGeneralQcList